import React from 'react'
import styles from './styles.module.scss'
import CTATitle from '../CTATitle'
import IconButton from 'srcReact/components/common2/IconButton'

function CTAWrapper({ show = true, title, subTitle, children, showClose = false, className, closeCTA }) {
  return show ? (
    <div className={`${styles.ctaWrapper} ${className}`}>
      {showClose && <IconButton className={styles.btnClose} iconName='close24' onClick={closeCTA} />}
      {title && <CTATitle title={title} subTitle={subTitle} />}

      {children}
    </div>
  ) : null
}

export default CTAWrapper
